import persistState from './creators/persistState';

export default persistState({
  key: 'dismissedAlerts',
  slicer: state => ({
    dismissedAlerts: state.dismissedAlerts,
  }),
});
